(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mez-product-hero-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const tracks = document.querySelectorAll('[data-mez-ph-track]');
    tracks.forEach((track) => {
      const slides = [...track.querySelectorAll('[data-mez-ph-slide]')];
      if (slides.length < 2) return;

      const root = track.closest('[id^="mez-ph-"]');
      const sid = root?.id?.replace('mez-ph-', '');
      let idx = slides.findIndex((s) => !s.hidden);
      if (idx < 0) idx = 0;

      const show = (next) => {
        slides[idx].hidden = true;
        slides[idx].classList.remove('mez-ph__slide--active');
        idx = (next + slides.length) % slides.length;
        slides[idx].hidden = false;
        slides[idx].classList.add('mez-ph__slide--active');
      };

      root.addEventListener('click', (e) => {
        const t = e.target;
        if (!(t instanceof Element)) return;
        if (t.closest(`[data-mez-ph-prev="${sid}"]`)) {
          e.preventDefault();
          show(idx - 1);
        }
        if (t.closest(`[data-mez-ph-next="${sid}"]`)) {
          e.preventDefault();
          show(idx + 1);
        }
      });

      const ms = parseInt(track.dataset.autoplay, 10);
      if (ms > 0) {
        setInterval(() => show(idx + 1), ms);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mez-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const tracks = document.querySelectorAll('[data-mez-ph-track]');
    tracks.forEach((track) => {
      const slides = [...track.querySelectorAll('[data-mez-ph-slide]')];
      if (slides.length < 2) return;

      const root = track.closest('[id^="mez-ph-"]');
      const sid = root?.id?.replace('mez-ph-', '');
      let idx = slides.findIndex((s) => !s.hidden);
      if (idx < 0) idx = 0;

      const show = (next) => {
        slides[idx].hidden = true;
        slides[idx].classList.remove('mez-ph__slide--active');
        idx = (next + slides.length) % slides.length;
        slides[idx].hidden = false;
        slides[idx].classList.add('mez-ph__slide--active');
      };

      root.addEventListener('click', (e) => {
        const t = e.target;
        if (!(t instanceof Element)) return;
        if (t.closest(`[data-mez-ph-prev="${sid}"]`)) {
          e.preventDefault();
          show(idx - 1);
        }
        if (t.closest(`[data-mez-ph-next="${sid}"]`)) {
          e.preventDefault();
          show(idx + 1);
        }
      });

      const ms = parseInt(track.dataset.autoplay, 10);
      if (ms > 0) {
        setInterval(() => show(idx + 1), ms);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
